<template>
  <div>
    <div class="flex items-center">
      <h4
        class="flex-shrink-0 pr-4 font-bebas tracking-wider text-lg leading-5 tracking-wider uppercase text-gray-600"
      >
        Topics Covered
      </h4>
      <div class="flex-1 border-t-2 border-green" />
    </div>
    <ul class="mt-6 lg:grid lg:grid-cols-2 lg:gap-x-8 lg:gap-y-5">
      <topic-grid-item
        v-for="(topic, idx) in session.topics"
        :topic="topic"
        :key="idx"
      ></topic-grid-item>
    </ul>
  </div>
</template>

<script>
import TopicGridItem from "./TopicGridItem";

export default {
  name: "TopicGrid",
  props: {
    session: {
      type: Object,
      required: true
    }
  },
  components: {
    TopicGridItem
  }
};
</script>

<style scoped></style>
